import React from 'react';
import { useTranslation } from '../../i18n';
import { AppIcon, getGameIconName } from '../shared/icons';

interface SelectedGameCardProps {
  gameId?: string;
  name?: string;
  extendedDescription?: string;
  className?: string;
}

export const SelectedGameCard: React.FC<SelectedGameCardProps> = ({
  gameId,
  name,
  extendedDescription,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div className={`selected-game-box ${className}`.trim()}>
      <div className="selected-game-header">
        <p className="selected-game-label">{t('lobby.gameSelection.selectedGame')}</p>
        <div className="selected-game-icon-name">
          {gameId && (
            <span className="selected-game-icon" aria-hidden="true">
              <AppIcon name={getGameIconName(gameId)} />
            </span>
          )}
          <span className="selected-game-name">{name}</span>
        </div>
      </div>
      {extendedDescription && (
        <div className="selected-game-description-carousel">
          <div className="carousel-content">
            {extendedDescription} • {extendedDescription} • {extendedDescription} •{' '}
            {extendedDescription} •
          </div>
        </div>
      )}
    </div>
  );
};
